import UserInformationTable from "./UserInformationTable";
import {useContext, useState} from "react";
import {MyContext} from "../context/myContext";
import DatePickerComponent from "./DatePickerComponent";
import {EnglishToPersian} from "numeral-convert";
import {useSelector} from "react-redux";
import {selectShowHistory} from "../features/common-states/commonStatesSlice";
import {selectRequestStyles} from "../features/request/requestSlice";

const HistoryPopUp = () => {
    const {title, handleShowHistory} = useContext(MyContext)
    const [persianDate, setPersianDate] = useState({startDate: '', endDate: ''})
    const showHistory = useSelector(selectShowHistory)
    const statusStyle = useSelector(selectRequestStyles)
    const handleStartDateChange = (timestamp, newDate) => {
        console.log(newDate)
        let persianNumbers = EnglishToPersian(newDate)
        setPersianDate({...persianDate, startDate: persianNumbers})
    }
    const handleEndDateChange = (timestamp, newDate) => {
        console.log(newDate)
        let persianNumbers = EnglishToPersian(newDate)
        setPersianDate({...persianDate, endDate: persianNumbers})
    }

    return(
        <div className={`${showHistory && 'show-history-popup'} history-popup`}>
            <div className='history-menu'>
                {statusStyle.length > 0 ? <i className="fa fa-times close-icon" onClick={handleShowHistory}></i> :
                    <div className='search-box'>
                        <button>اکسل</button>
                        <DatePickerComponent preSelected={persianDate.endDate.toString()} handleChange={handleEndDateChange} label='تا:' />
                        <DatePickerComponent preSelected={persianDate.startDate.toString()} handleChange={handleStartDateChange} label='از:' />
                    </div>
                }
                <div className='popup-title'><p>{title}</p></div>
            </div>
            <UserInformationTable />
            <div className='history-footer'>
                <button className='close-btn' onClick={handleShowHistory}>بستن</button>
            </div>
        </div>
    )
}

export default HistoryPopUp